import { io } from "socket.io-client";
import { SOCKET_URL } from "./constants";

const URL = SOCKET_URL;

export const socket = io(URL);
